import ChooseProfileView from "../../Views/Auth/ChooseProfile/ChooseProfileView";
import devotee from "../../assets/chooseProfile/devotee.png"
import {useNavigate  } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSignUpProfile } from "../../store/slices/authSlice";
import { logoutAction } from "../../store/actions/authAction";
import { useEffect } from "react";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";
function ChooseProfileScreen() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const {userInfo} = useSelector((state: any) => state.user);
  const profiles = [
    { id: 1, title: "Devotee",img:devotee,userType:"NORMALUSER" },
    // { id: 2, title: "Organization" ,img:org,userType:"ORGANISATION" },
    // { id: 3, title: "Pandit",img:pandit,userType:"PANDIT"},
    // { id: 4, title: "Pooja Samagri",img:pujasamagri},
    // { id: 5, title: "Astrologer",img:astrologer},
  ];

  useEffect(()=>{
    const storedUser = localStorage.getItem(LOCALSTORAGE_KEY.SIGNUPUSER);
    const userInStorage = storedUser ? JSON.parse(storedUser) : null;
    if(userInfo && !userInStorage){
      navigate("/login")
    }
    //For now directly navigate to Signup screen
    else{
      dispatch(setSignUpProfile(profiles[0]));
    navigate("/signup")
    }
  },[])

  const selectOneProfile = (profileSelected:any)=>{
    dispatch(setSignUpProfile(profileSelected));
    navigate("/signup")
  }

  const cancelAndGoToLogin = ()=>{
dispatch(logoutAction())
  }
  return (
    <div>
      <ChooseProfileView profiles={profiles} selectOneProfile={selectOneProfile} cancelAndGoToLogin={cancelAndGoToLogin} />
    </div>
  );
}

export default ChooseProfileScreen;
